import { NgFor } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonDirective } from '../../../shared/directives/button.directive';
import { ReplacePipe } from '../../../shared/pipes/replace.pipe';

@Component({
  selector: 'app-dialog-mode-switcher',
  templateUrl: './dialog-mode-switcher.component.html',
  styleUrls: ['./dialog-mode-switcher.component.scss'],
  standalone: true,
  imports: [NgFor, ButtonDirective, ReplacePipe],
})
export class DialogModeSwitcherComponent {
  @Input() modes: { key?: string; text: string }[];
  @Input() mode: string;
  @Input() location: string;
  @Output() modeChange = new EventEmitter();
}
